
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useArenaItemMedal } from '@/modules/arena/item/model/medal';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.ITEM.MEDAL,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { model, list, total, fetchList, actions } = useArenaItemMedal();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Rank', key: 'rank' },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-link',
                        theme: 'info',
                        tooltip: 'Link',
                        onclick: () => actions.link(model.arenaId, row.id)
                    }),
                    canShow: (row: any) => !row.linkedArena
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-unlink',
                        theme: 'warning',
                        tooltip: 'Unlink',
                        onclick: () => actions.unlink(model.arenaId, row.id)
                    }),
                    canShow: (row: any) => row.linkedArena
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, model, fetchList, actions };
    }
});
